/* eslint-disable no-param-reassign */

import { format } from 'date-fns';
import Timeslots from '../../booking/modules/timeslots';

// eslint-disable-next-line no-undef
const BASE_URL = `${siteUrl}api/gms/v1/reservation/`;

export default {
    /**
     * Find start times.
     */
    availableDates(date, numberOfPlayers) {
        const params = {
            date: format(date, 'YYYY-MM-DD'),
            nrOfPlayers: numberOfPlayers,
        };

        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}availableDates`, { params })
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.result.errors;
                }
                resolve(response.data.result);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },

    /**
     * Find start times.
     */
    findStartTimes(date, flight, claim, visitId) {
        flight.updating = true;

        const params = {
            date,
            startHole: claim.startHole,
            numberOfPlayers: flight.players.length,
            numberOfHoles: claim.numberOfHoles,
        };

        if (visitId) {
            params.visitId = visitId;
        }

        if (flight.id) {
            params.flightId = flight.id;
        }

        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}findStartTimes`, { params })
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.errors;
                }

                claim.times = Timeslots.getAvailableSlotsForClaimIndex(0, response.data.result.times, claim);
                flight.updating = false;

                // resolve(response.data.result);
                resolve(claim);
            })
            .catch((error) => {
                flight.updating = false;
                reject(error);
            });
        });
    },

    /**
     * Find start times.
     */
    reloadStartTimes(date, flight, claim, visitId) {
        flight.updating = false;

        const params = {
            date,
            startHole: claim.startHole,
            numberOfPlayers: flight.players.length,
            numberOfHoles: claim.numberOfHoles,
        };

        if (visitId) {
            params.visitId = visitId;
        }

        if (visitId && flight.id) {
            params.flightId = flight.id;
        }

        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}findStartTimes`, { params })
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.errors;
                }

                claim.times = Timeslots.getAvailableSlotsForClaimIndex(0, response.data.result.times, claim);
                flight.updating = false;

                resolve();
            })
            .catch((error) => {
                flight.updating = false;
                reject(error);
            });
        });
    },

    /**
     * Create visit claim.
     *
     * @param {Object} params
     */
    createClaim(params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}createClaim`, params)
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.result.errors;
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Update visit claim.
     *
     * @param {Object} params
     */
    updateClaim(reservationId, params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}updateClaim/${reservationId}`, params)
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.errors;
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);

                reject(error);
            });
        });
    },

    /**
     * Calls the GMS Reservation removeFlight method.
     *
     * @param {Object} params
     * @returns {Promise}
     */
    removeClaim(visitId, reservationId) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}removeClaim/${visitId}/reservation/${reservationId}`, postQs({}))
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Calls the GMS Reservation removeVisitClaim method.
     *
     * @param {Object} params
     * @returns {Promise}
     */
    removeVisitClaim(visitId) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}removeVisitClaim/${visitId}`, postQs({}))
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                reject(error.result);
            });
        });
    },

    /**
     * Fetch all the information for the current visit.
     *
     * @param {String} visitId
     * @returns {Promise}
     */
    findVisit(visitId) {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}visit/${visitId}`)
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Calls the GMS Reservation makeVisitDefinitive method.
     *
     * @param {Object} params
     * @returns {Promise}
     */
    makeVisitDefinitive(visitId) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}visit/${visitId}/makeDefinitive`, postQs({}))
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Calls the GMS Reservation makeVisitDefinitive method.
     *
     * @param {Object} params
     * @returns {Promise}
     */
    findAvailableAssets(visitId, flightId) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL + visitId}/findAvailableAssets/${flightId}`, postQs({}))
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Calls the GMS Reservation claimAssets method.
     *
     * @param {String} visitId
     * @param {String} flightId
     * @param {Object} params
     * @returns {Promise}
     */
    claimAssets(visitId, flightId, params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL + visitId}/${flightId}/assets`, postQs(params))
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Calls the GMS Reservation makeVisitDefinitive method.
     *
     * @param {Object} params
     * @returns {Promise}
     */
    setMainBooker(visitId, params) {
        return new Promise((resolve, reject) => {
            axios.put(`${BASE_URL}visit/${visitId}/mainBooker`, postQs(params))
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                reject(error.result);
            });
        });
    },

    /**
     * Calls the GMS Reservation makeVisitDefinitive method.
     *
     * @param {Object} params
     * @returns {Promise}
     */
    setMainBookerNames(params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}visit/mainBookerNames`, postQs(params))
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                reject(error.result);
            });
        });
    },

    /**
     * Calls the GMS Reservation claimDmp method.
     *
     * @param {String} visitId
     * @param {Object} params
     * @returns {Promise}
     */
    claimDmp(visitId, params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}visit/${visitId}/dmp`, postQs(params))
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Calls the GMS Reservation invites method.
     *
     * @param {String} visitId
     * @param {Object} params
     * @returns {Promise}
     */
    addInvites(visitId, params) {
        return new Promise((resolve, reject) => {
            axios.put(`${BASE_URL}visit/${visitId}/addInvites/`, postQs(params))
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                reject(error);
            });
        });
    },

    listVisits(params) {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}visit/list`, { params })
            .then((response) => {
                if (!response.data.success) {
                    throw response.data;
                }

                resolve(response.data);
            })
            .catch((error) => {
                console.log(error);
                reject();
            });
        });
    },
};
